<template>
  <div class="column">
    <div class="mrs mbm flex-container">
      <span class="text-left medium-6">
        Estás observando {{ count }} proyectos.
      </span>
      <div class="text-right medium-6">
        <span class="mls">
          <a :disabled="!enabled" @click="removeAllCompleted">
            Remover Todo Lo Completado
          </a>
          <span> |</span>
          <a :disabled="!enabled" @click="clearFilters">
            Remover Filtros
          </a>
        </span>
      </div>
    </div>
    <div class="flex-container align-middle mbm">
      <label for="filters">Filtros:</label>
      
      <select v-model="status" class="mbn mls mrs">
        <option
          v-for="(option, index) in briefOptions"
          :key="index"
          :value="option.value"
          :disabled="!enabled"
          class="mls mrs">
          {{ option.label }}
        </option>
      </select>
      
      <select v-model="daysLeft" class="mbn mls">
        <option
          v-for="(option, index) in dayOptions"
          :key="index"
          :value="option.value"
          :disabled="!enabled"
          class="mls mrs">
          {{ option.label }}
        </option>
      </select>
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      status: null,
      daysLeft: null,
      briefOptions: [
        {
          label: `Filtro de Status de Brief`,
          value: null,
        },
        {
          label: `Abierto`,
          isSelected: false,
          value: 'Open',
        },
        {
          label: `Decidiendo`,
          value: 'Deciding',
        },
        {
          label: `Cerrado`,
          value: 'Closed',
        },
      ],
      dayOptions: [
        {
          label: `Filtrar por días restantes`,
          value: null,
        },
        {
          label: `Menos de 1 día`,
          value: '1',
        },
        {
          label: `Menos de 3 días`,
          value: '3',
        },
        {
          label: `Menos de 7 días`,
          value: '7',
        },
        {
          label: `Menos de 10 días`,
          value: '10',
        },
        {
          label: `Menos de 15 días`,
          value: '15',
        },
      ],
    };
  },
  watch: {
    async status(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
    async daysLeft(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.update();
      }
    },
  },
  methods: {
    async update() {
      if (!this.enabled) {
        return;
      }
      this.$emit('filter-update', {
        status: this.status,
        daysLeft: this.daysLeft,
      });
    },
    removeAllCompleted() {
      this.$emit('remove-all-completed');
    },
    clearFilters() {
      this.status = null;
      this.daysLeft = null;
      this.update();
    },
  },
};
</script>
